import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { rem, Spacer } from 'design-system';
import { SpaceUserAvatar } from 'design-system/SpaceUserAvatar';
import StatusIcon from 'design-system/StatusIcon';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import TransactionAutoCreated from './TransactionAutoCreated';
const TransactionTopSection = ({ transaction }) => {
    const colors = useColors();
    const sections = useMemo(() => [
        transaction.isPending ? (<View key="PendingStatus" style={styles.row}>
          <StatusIcon state="in-progress"/>
          <Spacer.W8 />
          <Text TextThin-14 color={colors.text.statusInformational}>
            Pending
          </Text>
        </View>) : null,
        <SpaceUserAvatar key="SpaceUserAvatar" userId={transaction.userId} customText="’s transaction" xSmall style={styles.avatarUser}/>,
        <TransactionAutoCreated key="TransactionAutoCreated" transaction={transaction} isPill/>,
    ], [colors.text.statusInformational, transaction]);
    const hasSections = useMemo(() => sections.some((section) => section !== null), [sections]);
    if (!hasSections)
        return null;
    return <View style={styles.topSection}>{sections}</View>;
};
const styles = StyleSheet.create({
    topSection: {
        marginBottom: rem(12),
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf: 'center',
        marginTop: rem(-20),
        marginBottom: rem(28),
    },
    avatarUser: {
        alignSelf: 'center',
        marginTop: rem(-12),
        paddingBottom: rem(12),
    },
});
export default TransactionTopSection;
